<!--
  Besondere Bedingungen für die Safes — wortgleich übernommen aus den
  „Besonderen Bedingungen Vertraut" (Version 1.0 vom 21.08.2026), die bis zum
  01.09.2026 unter meinvertraut.de/vertragsbedingungen.html standen.

  Geändert wurden ausschließlich die Produktnamen (siehe Abschnitt „Hinweis
  zur Umbenennung"); die Regelungen selbst sind unverändert. Das ist Absicht:
  Für die bestehenden Verträge gilt nach Abschnitt 1 ohnehin die bei
  Vertragsschluss überlassene Fassung — der Hinweis stellt nur klar, dass es
  sich um dasselbe Produkt handelt.

  Version 1.2 (05.09.2026, Vorgabe Karsten nach Anwaltsprüfung P-5): Nr. 6
  nennt jetzt getrennt die Löschung aus dem Produktivsystem (30 Tage) und die
  vollständige Entfernung aus den Sicherungskopien (spätestens 90 Tage danach —
  entspricht der längsten Sicherungsgeneration von drei Monaten, siehe
  pull-app.sh auf dem Heim-Server) sowie die kostenpflichtige Wiederherstellung
  aus der Sicherung auf schriftlichen Antrag (Entgelt im Verzeichnis, Nr. 3).
  Erste inhaltliche Änderung seit „Vertraut" 1.0; für Altverträge gilt weiter
  die überlassene Fassung.

  Version 1.3 (08.09.2026, Vereinfachungsplan Teil 2, Anwaltsprüfung läuft
  parallel live): Nr. 2a) sprach von "gemeinsamer Nutzung von Zugangsdaten
  durch die vereinbarte Zahl von Nutzern" beim Passwort-Safe — das passte
  nicht zur Realität: Jedes Mitglied bekommt seit jeher ein eigenes,
  persönliches Konto, keinen gemeinsam genutzten Tresor (Vaultwarden
  unterstützt serverseitig nur Einzelkonten, keine geteilten Zugangsdaten).
  Korrigiert auf "eigenes, persönliches Konto mit eigenem Zugang" je
  Mitglied. Für Altverträge gilt weiter die überlassene Fassung.
-->
<div class="rechtstext">
  <h1>Besondere Bedingungen für die Safes</h1>
  <p>
    Vertragsergänzung für die Softwareprodukte <strong>KF Passwort-Safe</strong> und
    <strong>KF Akten-Safe</strong> von IT-Service Karsten Fischer, Martinshof 2,
    88410 Bad Wurzach (nachfolgend „Anbieter“).
  </p>

  <h2>Hinweis zur Umbenennung</h2>
  <p>
    Die hier beschriebenen Produkte wurden bis zum 1. September 2026 unter dem Namen
    „Vertraut“ angeboten; der Passwort-Safe hieß dort „Passwort-Safe“, der Akten-Safe
    „Dokumentenablage“. Es handelt sich um dieselben Leistungen mit unverändertem
    Umfang — geändert hat sich allein der Name. Für vor diesem Tag geschlossene
    Verträge gilt nach Abschnitt 1 die bei Vertragsschluss überlassene Fassung.
  </p>

  <h2>1. Geltung</h2>
  <p>
    Diese Besonderen Bedingungen gelten ergänzend zu den
    <a href="/agb">Allgemeinen Geschäftsbedingungen</a> des Anbieters und dem
    <a href="/entgelte">Preis- und Leistungsverzeichnis</a> für alle Verträge über die
    Safes. Bei Widersprüchen gehen eine individuelle Vereinbarung (Angebot/Auftrag) und
    diese Besonderen Bedingungen den Allgemeinen Geschäftsbedingungen vor. Der Anbieter
    kann diese Besonderen Bedingungen für künftige Vertragsschlüsse anpassen; für
    bestehende Verträge ist die bei Vertragsschluss überlassene Fassung maßgeblich.
  </p>

  <h2>2. Leistungsumfang</h2>
  <p>Das Angebot umfasst als Kombiprodukt:</p>
  <p>
    a) einen verschlüsselten <strong>Passwort-Safe</strong> zur Verwaltung von Zugangsdaten —
    jedes Mitglied der vereinbarten Nutzerzahl erhält dafür ein eigenes, persönliches Konto mit
    eigenem Zugang;<br />
    b) einen verschlüsselten, durchsuchbaren <strong>Akten-Safe</strong> mit der
    Möglichkeit, Inhalte in natürlicher Sprache abzufragen;<br />
    c) die Einrichtung und Einweisung durch den Anbieter (im veröffentlichten
    Servicegebiet vor Ort, im Übrigen per Fernzugriff);<br />
    d) den Produkt-Support für die vorgenannten Bestandteile (Fragen zur Nutzung,
    Störungen des Produkts).
  </p>
  <p>
    Die Daten werden auf Servern in einem Rechenzentrum in Deutschland gespeichert und
    regelmäßig in verschlüsselter Form gesichert. Die vereinbarte Nutzerzahl und das
    Speicherkontingent ergeben sich aus dem Angebot bzw. dem Preis- und
    Leistungsverzeichnis.
  </p>
  <p>
    Allgemeine IT-Dienstleistungen, die über den Produkt-Support hinausgehen (z. B. Hilfe
    bei Geräten, Druckern oder sonstiger Software), sind nicht Bestandteil der Safes und
    werden leistungsbezogen nach dem Preis- und Leistungsverzeichnis abgerechnet.
  </p>

  <h2>3. Verschlüsselung (Zero-Knowledge)</h2>
  <p>
    Passwort-Safe und Akten-Safe arbeiten mit einer Zero-Knowledge-Verschlüsselung: Der
    Anbieter erhält und speichert ausschließlich verschlüsselte Daten und hat zu keinem
    Zeitpunkt Kenntnis von Master-Passwörtern oder unverschlüsselten Inhalten. Bei Verlust
    der für die Entschlüsselung erforderlichen Zugangsdaten ist der Anbieter technisch
    nicht in der Lage, gespeicherte Inhalte wiederherzustellen. Der Kunde ist für die
    sichere Aufbewahrung der Zugangsdaten und geeignete eigene Vorkehrungen (z. B.
    geregelte Verantwortlichkeiten bei Wechseln im Vorstand oder Team) selbst
    verantwortlich; der Anbieter unterstützt hierbei im Rahmen der Einweisung.
  </p>

  <h2>4. Entgelte und Abrechnung</h2>
  <p>
    Die Entgelte ergeben sich aus dem Angebot des Anbieters bzw. dem Preis- und
    Leistungsverzeichnis. Sofern nicht abweichend vereinbart, werden die Safes für Vereine
    als Jahresrechnung und für Betriebe je Quartal abgerechnet; die Einrichtung wird
    einmalig mit der ersten Rechnung berechnet. Die Zahlung erfolgt per Rechnung, sofern
    keine automatisierte Zahlung vereinbart ist.
  </p>

  <h2>5. Laufzeit und Kündigung</h2>
  <p>
    a) Für Vereine beträgt die Laufzeit zwölf Monate ab dem vereinbarten
    Bereitstellungstermin. Sie verlängert sich um jeweils weitere zwölf Monate, wenn der
    Vertrag nicht mit einer Frist von einem Monat zum Ende der jeweiligen Laufzeit
    gekündigt wird.<br />
    b) Für Betriebe läuft der Vertrag auf unbestimmte Zeit und kann von beiden Seiten
    jederzeit zum Ende des laufenden Kalendermonats gekündigt werden; bereits berechnete
    Quartalsentgelte werden für volle, nicht genutzte Kalendermonate nach Vertragsende
    erstattet.<br />
    c) Die Kündigung kann per E-Mail oder über das Kundenportal erfolgen. Das Recht zur
    außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
  </p>

  <h2>6. Vertragsende und Datenlöschung</h2>
  <p>
    Mit Vertragsende wird der Zugang deaktiviert. Der Kunde kann seine Daten bis zum
    Vertragsende exportieren; der Anbieter unterstützt auf Wunsch im Rahmen des
    Produkt-Supports. Die gespeicherten, verschlüsselten Daten werden 30 Tage nach
    Vertragsende aus dem Produktivsystem gelöscht und spätestens 90 Tage danach – also
    spätestens 120 Tage nach Vertragsende – auch aus sämtlichen Sicherungskopien vollständig
    entfernt, sofern keine gesetzliche Aufbewahrungspflicht entgegensteht.
  </p>
  <p>
    Solange die Daten noch in einer Sicherungskopie vorhanden sind, kann der Anbieter ein
    gelöschtes Konto auf schriftlichen Antrag des Kunden aus der Sicherung wiederherstellen.
    Dies ist eine kostenpflichtige Sonderleistung; das Entgelt ergibt sich aus dem
    <a href="/entgelte">Preis- und Leistungsverzeichnis</a>. Nach der vollständigen Entfernung
    aus den Sicherungskopien ist eine Wiederherstellung ausgeschlossen.
  </p>

  <h2>7. Weiterentwicklung</h2>
  <p>
    Der Anbieter entwickelt die Safes laufend weiter und kann Funktionen ergänzen oder in
    zumutbarem Umfang anpassen, sofern der vertraglich vereinbarte Leistungsumfang im Kern
    erhalten bleibt. Schränkt der Anbieter den Leistungsumfang wesentlich ein, kann der
    Kunde den Vertrag außerordentlich zum Zeitpunkt des Wirksamwerdens der Einschränkung
    kündigen.
  </p>

  <p class="stand">
    Stand: 08.09.2026 · Version 1.3 (ersetzt Version 1.2 vom 05.09.2026; geändert: Nr. 2a) –
    Passwort-Safe: eigenes Konto je Mitglied statt gemeinsamer Nutzung von Zugangsdaten)
  </p>
</div>
